import { Controller } from "@hotwired/stimulus"

const INITIAL_DISPLAY_DELAY = 750

export default class extends Controller {
  static targets = ["panel", "declineButton"]

  connect() {
    if (this.#preference()) {
      this.#hideImmediately()
    } else {
      this.showTimer = setTimeout(() => this.#show(false), INITIAL_DISPLAY_DELAY)
    }
  }

  disconnect() {
    clearTimeout(this.showTimer)
    clearTimeout(this.hideTimer)
    cancelAnimationFrame(this.showFrame)
  }

  open() {
    this.#show(true)
  }

  #preference() {
    const meta = this.element.ownerDocument.querySelector('meta[name="optofriend-analytics"]')
    return meta ? JSON.parse(meta.content).preference : null
  }

  #show(moveFocus) {
    clearTimeout(this.hideTimer)
    this.panelTarget.hidden = false
    this.showFrame = requestAnimationFrame(() => {
      this.panelTarget.classList.remove("pointer-events-none", "translate-y-3", "opacity-0")

      if (moveFocus) this.declineButtonTarget.focus()
    })
  }

  #hideImmediately() {
    this.panelTarget.hidden = true
  }
}
